import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react'

function SubjectView({subscription, onTopics, onQuestions}) {
    const {subject : {subjectGrade : {nameTags : gradeNameTags = []}}, selectedSubjectNameTag : {name, language : {id : languageId}}} = subscription;
    const selectedGradeNameTag = gradeNameTags.find(tag => tag.language.id === languageId) // Assuming you want to use the first selected tag
    const {name: gradeName} = selectedGradeNameTag || {};

    const _onTopics = () => {
        onTopics(subscription.subject.id);
    }

    const _onQuestions = () => {
        onQuestions(subscription.subject.id);
    }
    
  return (
    <Paper elevation={3}>
      <Box
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="button" gutterBottom>
          {" "}
          {`${name} - ${gradeName}`}{" "}
        </Typography>
      </Box>

      <Box
        sx={{ padding: 2, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={_onQuestions}
        >
          {"Questions"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={_onTopics}
        >
          {"Sylabus"}
        </Button>
        <Button variant="contained" color="primary" size="small">
          {"Past papers"}
        </Button>
      </Box>
    </Paper>
  );
}

export default SubjectView